import { Component, OnInit, Input } from '@angular/core';
import { GenericoSlideAnim } from '../etc/generico-animation'
import { SidebarAnim, OverlayAnim } from '../etc/sidebar-animation'
import { MarianomGeneral } from '../marianom-general.service';
import { MenuMmaxInterface } from '../../components/etc/mmax-menu.interface';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { CategoriasWebMenu, EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';

@Component({
  selector: 'categorias-generico',
  templateUrl: './categorias-generico.component.html',
  styleUrls: ['./categorias-generico.component.scss'],
  animations: [GenericoSlideAnim, SidebarAnim, OverlayAnim]

})

export class CategoriasGenericoComponent implements OnInit {
  @Input('mode') modo: string;
  @Input() login: string;
  @Input() myData: string;
  @Input() categoria: CategoriasWebMenu;

  menues: { nombre: string; url: string; urlmobile: string; icourl: string; }[];
  swicher: boolean;
  isLogued: boolean;
  width: number = window.innerWidth;
  constructor(private serv: MarianomGeneral, private genServ: EcommerceGenericoService, private route: ActivatedRoute, private modal: ModalService) {
    this.modo = this.modo || 'normal';
    this.login = this.login || 'none';
    this.myData = this.login || 'none';
    this.swicher = false;

    this.menues = [
      {
        nombre: 'Mis Datos',
        url: '/misdatos',
        urlmobile: '/app-mobile/app/account',
        icourl: 'mdi mdi-credit-card-outline'
      }
    ];

    this.isLogued = this.serv.isloged()
  }

  ngOnInit(): void {
    if (this.isLogued === false) {
      this.myData = 'none';
      this.login = 'block';
    } else {
      this.myData = 'flex';
      this.login = 'none';
    }
  }

  get menus(): MenuMmaxInterface[] {
    return this.serv.rutas
  }

  get desplegado(): boolean {
    return this.serv.desplegadocat;
  }

  get categorias() {
    return this.genServ.getCategoriasWeb();
  }

  get user() {
    return this.genServ.getUser();
  }

  get menuOfertas(): MenuMmaxInterface | undefined {
    return this.menus.find(m => m.ruta === 'ofertas' && !m.oculto);
  }

  openLogin() {
    window.scrollTo(0, 0);
    this.serv.desplegaryCerrar(false);
    setTimeout(() => {
      this.modal.open('login-modal-1');
    }, 100);
  }

  cerrarSesion() {
    this.abrirCerrar();
    setTimeout(() => {
      this.modal.open('modal-salir');
    }, 100);
  }

  abrirInstitucional(modalId: string) {
    this.abrirCerrar();
    setTimeout(() => {
      this.modal.open(modalId);
    }, 100);
  }

  cerrarCateg(event: CategoriasWebMenu) {
    for (let i = 0; i < this.categorias.length; i++) {
      const element = this.categorias[i];
      element.desplegado = false;
    }

    if (event.desplegado === true) {
      event.desplegado = false;
    }
    if (event.desplegado === false) {
      event.desplegado = true;
    }
  }

  abrirCerrar() {
    window.scrollTo(0, 0)
    if (this.serv.isloged() === false) {
      this.myData = 'none';
      this.login = 'block';
    } else {
      this.myData = 'flex';
      this.login = 'none';
    }

    if (this.enVistaProductosPantallaTablet()) {
      this.serv.desplegaryCerrar(!this.desplegado);
      this.serv.toggleSideBarBusqueda();
      return
    }

    if (this.enVistaPantallaEscritorio()) {
      // En escritorio solo abrimos/cerramos categorías, sin tocar el sidebar de búsqueda
      this.serv.desplegaryCerrar(!this.desplegado);
      return
    }

    this.serv.desplegaryCerrar(!this.desplegado);
    this.serv.toggleSideBarBusqueda()
  }

  gotoURL(url: string) {
    for (let i = 0; i < this.menus.length; i++) {
      const element = this.menus[i];
      element.activo = false;
    }
    this.serv.gotoURL(url, this.route);
    this.abrirCerrar();
  }

  gotoBusqueda(url: string) {/// METODO A CAMBIAR, NAVIGATOR
    for (let i = 0; i < this.menus.length; i++) {
      const element = this.menus[i];
      element.activo = false;
    }
    this.serv.gotoURL(url, this.route);
    this.serv.goToProducts(true);
  }

  menuclick(menus: MenuMmaxInterface) {
    window.scrollTo(0, 0)
    if (!this.serv.isloged()) {
      if (menus.ruta == "historial" || menus.ruta == "sucursales") {
        this.serv.abrirModalLogin();
      } else {
        this.serv.gotoURL("/" + menus.ruta, this.route);
        this.serv.activatethis(menus);
      }
    } else {
      this.serv.gotoURL("/" + menus.ruta, this.route);
      this.serv.activatethis(menus);
    }

  }

  iraLand() {
    this.serv.navigator.goLandPage(this.route);
    this.serv.cerrarUI();
  }

  enVistaProductosPantallaTablet() {
    this.width = window.innerWidth;
    //console.log('enVistaProductosPantallaTablet', this.serv.getMenuActivoNombre() === 'Productos', this.width > 599, this.width < 1000, this.route.url)
    //console.log('desplegado=', this.desplegado)
    return (this.serv.getMenuActivoNombre() === 'Productos' && this.width > 599 && this.width < 1000)
  }

  enVistaPantallaEscritorio() {
    this.width = window.innerWidth;
    return (this.width > 1000)
  }

  irACategoria(categoria: CategoriasWebMenu, categoriaPadre?: CategoriasWebMenu) {
    this.genServ.busquedaCategoria(categoria, categoriaPadre || categoria);
    this.serv.navigator.goSearch(this.route);
    this.abrirCerrar();
  }

  toggleCategoriaMobile(categoria: CategoriasWebMenu) {
    // La mayoría de los artículos cuelgan de la subcategoría, no de la categoría de primer
    // nivel — por eso si tiene subcategorías las mostramos in-place en vez de navegar directo.
    if (!categoria.subCategorias || categoria.subCategorias.length === 0) {
      this.irACategoria(categoria);
      return;
    }
    this.categorias.forEach(c => {
      if (c !== categoria) c.desplegado = false;
    });
    categoria.desplegado = !categoria.desplegado;
  }

  toggleSubCategoriaMobile(sub: CategoriasWebMenu, categoriaPadre: CategoriasWebMenu) {
    if (!sub.subCategorias || sub.subCategorias.length === 0) {
      this.irACategoria(sub, categoriaPadre);
      return;
    }
    categoriaPadre.subCategorias.forEach(s => {
      if (s !== sub) s.desplegado = false;
    });
    sub.desplegado = !sub.desplegado;
  }

  reiniciarFiltroCategoria(categoriaSeleccionada: any) {
    let seCerroDespliegueDeCategoria = categoriaSeleccionada.desplegado === false
    //console.log('reiniciarFiltroCategoria',categoriaSeleccionada)
    if (seCerroDespliegueDeCategoria) {
      this.genServ.iniciarbusqueda('');
    }
  }
}
